import React, { useState, useEffect } from 'react';
import {
  Popover,
  Button,
  Menu,
  Position,
  ChevronDownIcon,
  ChevronUpIcon,
} from 'evergreen-ui';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import SectionCard from '../../../../components/section-card';
import { api } from '../../../../services/api';

const ResolvedTicketsChart = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [metricData, setMetricData] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(7);

  let unmounted = false;
  async function fetchData() {
    setLoading(true);
    try {
      const { data } = await api.metrics.resolvedTickets(selectedOption);
      if (!unmounted) {
        setMetricData(data);
        setLoading(false);
      }
    } catch (e) {
      if (!unmounted) {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    fetchData();

    return () => {
      unmounted = true;
    };
  }, [selectedOption]);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  const chartData = {
    labels: Object.keys(metricData),
    datasets: [
      {
        label: 'Approved',
        data: Object.values(metricData).map((v) => v.approved),
        borderColor: '#15E891',
        pointRadius: 5,
        pointHoverRadius: 8,
      },
      {
        label: 'Declined',
        data: Object.values(metricData).map((v) => v.declined),
        borderColor: '#F24C6A',
        pointRadius: 5,
        pointHoverRadius: 8,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      line: {
        tension: 0.20,
      },
    },
  };

  const optionsMenu = (
    <Menu>
      <Menu.Option
        onSelect={() => setSelectedOption(7)}
        isSelected={selectedOption === 7}>
        1 Week
      </Menu.Option>
      <Menu.Option
        onSelect={() => setSelectedOption(14)}
        isSelected={selectedOption === 14}>
        2 Weeks
      </Menu.Option>
      <Menu.Option
        onSelect={() => setSelectedOption(30)}
        isSelected={selectedOption === 30}>
        1 Month
      </Menu.Option>
      <Menu.Option
        onSelect={() => setSelectedOption(90)}
        isSelected={selectedOption === 90}>
        3 Months
      </Menu.Option>
      <Menu.Option
        onSelect={() => setSelectedOption(180)}
        isSelected={selectedOption === 180}>
        6 Months
      </Menu.Option>
    </Menu>
  );

  return (
    <SectionCard
      title="Resolved tickets"
      button={(
        <Popover
          position={Position.BOTTOM_RIGHT}
          onOpen={() => setMenuOpen(true)}
          onClose={() => setMenuOpen(false)}
          content={optionsMenu}>
          <Button
            size="small"
            iconAfter={menuOpen ? ChevronUpIcon : ChevronDownIcon}
            appearance="minimal">
            1 Week
          </Button>
        </Popover>
      )}>
      <Line
        options={chartOptions}
        data={chartData} />
    </SectionCard>
  );
};

export default ResolvedTicketsChart;
